const BANNER_TYPE = {
  unlockMemberPricing: 'UNLOCK_MEMBER_PRICING',
  memberPricingUnlocked: 'MEMBER_PRICING_UNLOCKED',
};

export default BANNER_TYPE;
